<template>
  <div class="submit-order">
    <div class="top">
      <van-form ref="form">
        <div class="t0" :class="{ pd: !student.id }">
          <van-cell
            center
            :border="false"
            :title="student.name"
            :label="student.gradeName"
            @click="addStu"
          >
            <template #right-icon>
              <span class="op">更换/新增</span
              ><van-icon name="arrow" size="var(--fs-lg)" color="var(--g4)" />
            </template>
          </van-cell>
          <div class="add flex-between" v-if="!student.id" @click="addStu">
            <div>
              <div>请选择报名学员</div>
              <div class="tips">选择已有学员或新增学员</div>
            </div>
            <van-icon name="arrow" size="var(--fs-lg)" color="var(--g5)" />
          </div>
        </div>
        <!-- 班级 -->
        <div class="t1" v-if="commodity && commodityType == 1">
          <div class="til">{{ commodity.commodityName }}</div>
          <div
            class="line curriculum-name"
            v-if="commodity.curriculumName"
          >
            <span v-if="commodity.curriculumName"> {{ commodity.curriculumName }} </span>
          </div>
          <div class="line">{{ commodity | formateClassTime }}</div>
          <div class="line" v-if="getTeachers(commodity.teachers) && getTeachers(commodity.teachers).length > 0">
            上课老师：{{ getTeachers(commodity.teachers).map(i => i.teacherName).join('、') }}
          </div>
          <div class="line" v-if="commodity.campusName">
            <span class="campus-tag">{{ commodity.campusName }}</span>
          </div>
          <div class="line2 flex-between">
            <div class="money">
              ￥{{ selectedPriceObj.price | formatNumber }}
              <span class="total">共{{ selectedPriceObj.priceNum }}{{ selectedPriceObj.priceUnitName }}</span>
            </div>
            <div class="num flex-center">
              <van-icon name="cross" size="var(--fs-sm)" />
              <div>{{ 1 }}</div>
            </div>
          </div>
        </div>
        <!-- 物品 -->
        <div class="t1" v-if="commodity && commodityType == 0">
          <div class="til">{{ commodity.commodityName }}</div>
          <div class="line">物品规格：{{ selectedPriceObj.priceName }}</div>
          <div class="line">领取校区：{{ selectedCampusObj.name }}</div>

          <div class="line2 flex-between">
            <div class="money">
              ￥{{ selectedPriceObj.price | formatNumber }}
              <span class="total">/{{ selectedPriceObj.priceUnitName }}</span>
            </div>
            <div class="num flex-center">
              <van-icon name="cross" size="var(--fs-sm)" />
              <div>{{ 1 }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="t3" v-if="false">
          <van-field
            size="large"
            label="课程金额"
            :formatter="(v) => v.trimLeft()"
            placeholder="请输入"
            required
            maxlength="20"
            :rules="[{ required: true, message: '必填' }]"
          />

          <van-field
            size="large"
            readonly
            clickable
            name="publicGrade"
            label="优惠券"
            required
            :right-icon="'arrow'"
            placeholder="请选择"
            :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
          />
          <van-field
            size="large"
            readonly
            clickable
            name="picker"
            label="其他优惠"
            required
            :right-icon="'arrow'"
            placeholder="请选择"
            @click.stop="showRelationShipPicker = true"
            :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
          />

          <div class="t3-bottom ">
            <div class="c van-hairline--top-bottom">
              合计: <span class="l1">￥</span>
              <span class="l2">{{ 900 }}</span>
            </div>
          </div>
        </div> -->
        <van-cell
          v-if="pointExchange"
          title="使用积分抵扣"
          :label="`可用积分${+pointExchange.point}，可用积分${+pointExchange.computePointCostValue}抵扣${app.tool.formatNumber(+pointExchange.computePromotionMoney)}元`"
          title-class="tctil"
        >
          <template #title>
            <van-popover
                v-model="popxx"
                class="popover-wrap"
                theme="dark"
                trigger="click"
                placement="top-start"
                :offset="[0, 4]"
              >
                <div>{{`每${pointExchange.pointExchangeEach}积分，可抵扣学费${app.tool.formatNumber(pointExchange.pointExchangeMoneyEach)}元`}}</div>
                <template #reference>
                  <div>
                    使用积分抵扣
                    <van-icon name="question-o" class="tips-icon" />
                  </div>
                </template>
            </van-popover>
          </template>
          <template #right-icon>
            <van-checkbox v-model="usePointExchange" size="calc(var(--w) * 24)" :disabled="!(pointExchange.computePointCostValue > 0 && pointExchange.computePromotionMoney >= 1)"/>
          </template>
        </van-cell>

        <van-field
          style="margin-top: 12px"
          type="textarea"
          v-model="buyerNotes"
          autosize
          rows="2"
          maxlength="500"
          placeholder="请输入备注信息"
          show-word-limit
        />
      </van-form>
    </div>

    <div class="bottom flex-between">
      <div class="b1">共<span class="num">1</span>项</div>
      <div>应付：</div>
      <div class="b3">￥</div>
      <div class="b4" v-if="commodity">
        {{ (usePointExchange ? calcPayFact : selectedPriceObj.price) | formatNumber }}
      </div>
      <van-button
        class="b5"
        square round
        type="primary"
        :loading="submitOrdering"
        loading-text="提交中"
        @click="submitOrder"
        >立即支付</van-button
      >
    </div>
  </div>
</template>

<script>
import { getPaikePeriod } from '@x3/vue/filters/filters.js';

export default {
  name: 'order-submit',
  data() {
    return {
      popxx: false,
      pageTitle: '确认订单',
      //  购买的商品id
      id: this.$route.query.id,
      commodity: null,
      student: {},
      submitOrdering: false,
      priceId: this.$route.query.priceId,
      campusId: this.$route.query.campusId,
      commodityType: parseInt(this.$route.query.commodityType),
      commodityCampus: this.$route.query.commodityCampus,
      promotion: [],
      usePointExchange: false,
      calcPayFact: 0,
      selectedPriceObj: {
        id: '',
      },
      selectedCampusObj: {
        id: '',
      },
      buyerNotes: ''
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
    // 积分兑换
    pointExchange(){
      return this.commodity && this.commodity.enableMemberPoint && this.promotion.find(item=> item.promotionType === 'POINT');
    }
  },
  filters: {
    formateClassTime(c) {
      let s1 = '',
        s2 = '';
      c.planOpenClassTime &&
        (s1 = app.tool.date.formatDatetime(c.planOpenClassTime, 'MM月dd日') + '起');
      c.commodityClassDetailExtendList && (s2 = getPaikePeriod(c.commodityClassDetailExtendList));

      return s1 && s2 ? `${s1} · ${s2}` : `${s1}${s2}`;
    },
  },
  methods: {
    async getYouhui(){
      const res = await this.$api.promotionValidPage({
        studentId: this.student.id
      });
      this.promotion = res.data;
      this.calcJiFen();
    },
    async calcJiFen(){
      let calcParams = {
        walletRemainMoney: 0,
        calculatePayFactRos: [],
        supportPromotions: this.pointExchange ? [this.pointExchange] : [],
      };
      calcParams.calculatePayFactRos.push({
        price: this.selectedPriceObj.price,
        productQuantity: 1,
        discountMoney: 0,
        discount: '',
      });
      
      const result = await this.$api.utilsCalculatePayFact(calcParams);
      const pointExchange = result.data.supportPromotions.find(item=>item.promotionType === 'POINT');
      if (pointExchange) {
        Object.assign(this.pointExchange, pointExchange);
        this.calcPayFact = result.data.payFact;
      }
    },

    getTeachers(teachers) {
      let arr = teachers || [];
      return arr.filter(v=>v.teacherRule === 0);
    },
    addStu() {
      const campusId = this.commodityType == 0 ? this.commodityCampus : this.commodity.campusId
      this.$router.push(`/studentSelect?campusId=${campusId}&parentId=${this.$route.query.parentId}`);
      this.$onceBus('select-student', stu => {
        this.student = stu;
        this.usePointExchange = false;
        // 查询积分.
        this.getYouhui();
      });
    },
    async verify() {
      let msg = '';

      if (!this.student.id) {
        msg = '请先添加报名学员。';
      }

      if (msg) {
        vant.Toast.fail(msg);
        return Promise.reject(msg);
      } else {
        return Promise.resolve('校验通过。');
      }
    },
    async submitOrder() {
      await this.verify();

      if (this.userInfo.companyAppOpenList.indexOf("WALLET")<0) {
        if ((this.usePointExchange && this.calcPayFact > 0 ) || (!this.usePointExchange && this.selectedPriceObj.payFact > 0)) {
          vant.Dialog.alert({
            message: '机构未开通线上支付，请联系机构老师进行购买'
          })
          return;
        }
      }


      this.submitOrdering = true;
      try {
        let res = await this.$api.createOrder({
          studentId: this.student.parentId ? '' : this.student.id, //通过列表选择的->studentId传student.id
          studentName: this.student.parentId ? '' : this.student.name,
          parentChildId: this.student.parentId ? this.student.id : '', //通过新学员报名的->parentChildId传student.id
          parentChildName: this.student.parentId ? this.student.name : '',
          payFact: this.selectedPriceObj.price,
          totalMoney: this.selectedPriceObj.price,
          campusId: this.commodityType == 0 ? this.commodityCampus : this.commodity.campusId, // 物品领用校区/班级所在校区
          orderInfoRo: {
            buyerNotes: '',
          },
          orderItems: [
            {
              // 商品ID
              productId: this.id,
              // 购买数量
              productQuantity: 1,
              // 商品类型，0：物品，1：班级
              productType: this.commodityType,
              // 价目ID
              priceItemId: this.selectedPriceObj.priceItemId,
              // 价目明细ID
              priceItemDetailId: this.selectedPriceObj.priceItemDetailId,
              // 实付金额
              // payFact: ""
              // 物品领用校区
              campusId: this.commodityType == 0 ? this.commodityCampus : '',
              price: this.selectedPriceObj.price,
            },
          ],
          supportPromotions: this.usePointExchange && this.pointExchange ? [this.pointExchange] : [],
          buyerNotes: this.buyerNotes,
        });

        if (res.code == 200) {
          // 后端大佬(刘鹏)说，状态码为200时
          // 也需要判断一个是否有orderId,如果没有可能是后端有问题
          // 但后端暂时还没有找到问题具体原因，所以前端也先判断一下
          if (!res.data.id) {
            this.$toast('课程太火爆，请稍后重试');
            return false;
          }
          if (res.data.orderStatus) {
            this.$router.push(`/payResult?id=${res.data.id}`);
          } else {
            this.pay(res.data.id);
          }
          this.submitOrdering = false;
        } else {
          this.submitOrdering = false;
          // 已经存在重复订单
          // 让用户选择是否需要跳转到订单页岩
          if (res.code === 740000001) {
            // 修改价格添加确认提示
            this.$dialog
              .confirm({
                message: '学员存在同一商品未支付订单，请前往完成支付。',
                confirmButtonText: '查看',
              })
              .then(async () => {
                this.$router.push('/orderList?active=1');
              })
              .catch(err => {
                console.log(err);
              });
          } else if (res.code === 820000001 || res.code === 740000003) {
            //820000001授权校区被改变了/740000003商品价格被删了
            this.refreshDetail();
          } else {
            this.$toast.fail(res.msg);
          }
        }
      } catch (error) {
        this.submitOrdering = false;
      }
    },
    async pay(id) {
      try {
        app.parent.pay(id, 1);

        setTimeout(() => (this.submitOrdering = false), 3000);
      } catch (error) {
        this.submitOrdering = false;
      }
    },
    refreshDetail() {
      this.$dialog
        .alert({
          message: '商品信息已更新，请重新下单',
          confirmButtonText: '返回',
        })
        .then(() => {
          app.vue.$emit('refresh-product-detail');
          this.$router.back();
        });
    },
  },
  created() {
    if (this.userInfo.id) {
      let _pro =
        this.commodityType == 1 ? this.$api.queryCommodityGet : this.$api.studentGoodsDetails;
      let params =
        this.commodityType == 1
          ? {
              commodityInfoId: this.id,
            }
          : {
              commodityGoodsId: this.id,
            };
      _pro(params).then(res => {
        if (res.code == 200) {
          this.commodity = res.data;
          // 选中的价格
          let pList =
            this.commodityType == 1
              ? this.commodity.commodityPriceItemDetailList
              : this.commodity.commodityPriceItemList;
          if (this.priceId) {
            pList.forEach(item => {
              let equalId = this.commodityType == 0 ? item.priceItemId : item.id;
              if (equalId == this.priceId) {
                this.selectedPriceObj = item;
              }
            });

            if (this.commodityType == 0 && !this.selectedPriceObj.priceItemId) {
              //物品判断是否存在
              this.refreshDetail();
            }
            if (this.commodityType != 0 && !this.selectedPriceObj.id) {
              //非物品判断是否存在
              this.refreshDetail();
            }
          } else {
            this.selectedPriceObj = pList[0];
          }
          // 选中的校区
          if (this.commodityType == 0) {
            if (!res.data.campusList) {
              this.refreshDetail();
            } else {
              res.data.campusList.forEach(item => {
                if (item.id == this.commodityCampus) {
                  this.selectedCampusObj = item;
                }
              });
              if (!this.selectedCampusObj.id) {
                this.refreshDetail();
              }
            }
          }
        }
      });
    } else {
      app.parent.login();
    }
  },
};
</script>

<style lang="scss" scoped>
.submit-order {
  display: flex;
  flex-direction: column;
  .top {
    flex: 1;
    padding: calc(var(--gap) * 16) calc(var(--gap) * 8);
    overflow: auto;
    .t0,
    .t1,
    .t2,
    .t3 {
      background: var(--white);
      border-radius: var(--radius-sm);
      overflow: hidden;
    }
    .t0 {
      position: relative;
      padding: 0;
      &.pd {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      }
      .add {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0 calc(var(--gap) * 16);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--c5);
        background: var(--white);
        z-index: 2;
        .tips {
          // margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g6);
        }
      }
      .op {
        color: var(--c5);
        margin-right: calc(var(--gap) * 4);
      }
    }
    .t1,
    .t3 {
      margin-top: calc(var(--gap) * 16);
    }
    .t1 {
      position: relative;
      padding: calc(var(--gap) * 16);
      .til {
        margin-bottom: calc(var(--gap) * 4);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        font-weight: bold;
        color: var(--g8);
      }
      .line {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        padding: calc(var(--gap) * 4) 0;
        color: var(--g6);
        .campus-tag {
          color: var(--g7);
          font-size: var(--fs-sm);
          line-height: 16px;
          background: var(--g1);
          padding: 0 calc(var(--gap) * 4);
          text-shadow: 0px calc(var(--gap) * 2) calc(var(--gap) * 10) rgba(30, 31, 32, 0.09);
          border-radius: var(--radius-base);
        }
      }
      .curriculum-name {
        font-size: var(--fs-md);
        color: var(--g6);
      }
      .line2 {
        margin-top: calc(var(--gap) * 8);
        padding: calc(var(--gap) * 16) 0 0;
        .money {
          text-align: right;
          font-size: var(--fs-md);
          font-weight: var(--bold);
          color: var(--g7);
          .total {
            color: var(--g6);
          }
        }
        .num {
          font-size: var(--fs-md);
          color: var(--g8);
        }
        &::before {
          content: '';
          position: absolute;
          bottom: calc(var(--w) * 46);
          left: 0;
          right: 0;
          height: 1px;
          background: var(--g3);
          transform: scaleY(0.5);
        }
      }
    }

    .t3 {
      .t3-bottom {
        padding: 0 calc(var(--gap) * 16);
        .c {
          padding-right: calc(var(--gap) * 11);
          line-height: calc(var(--w) * 56);
          text-align: right;
          font-size: var(--fs-sm);
          color: var(--g6);
        }
        .l1 {
          color: #ff5536;
        }
        .l2 {
          color: #ff5536;
          font-size: var(--fs-ex1);
        }
      }
    }
  }
  .bottom {
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    background: var(--white);
    font-size: var(--fs-sm);
    color: var(--g6);
    .b1 {
      margin-right: calc(var(--gap) * 16);
      .num {
        color: var(--g8);
      }
    }
    .b3 {
      color: #ff5536;
      margin-right: calc(var(--gap) * 2);
    }
    .b4 {
      flex: 1;
      color: #ff5536;
      font-size: var(--fs-ex1);
    }
    .b5 {
      font-size: var(--fs-md);
      height: calc(var(--w) * 40);
    }
  }
}
</style>